import { USER_FB_TOKEN } from '../constants/ActionTypes';

const initialState = {
  fbAccessToken: '',
};

export default function fbuser(state = initialState, action) {
  switch (action.type) {
    case USER_FB_TOKEN:
      console.log('setting token:', action.token);
      return {
        ...state,
        fbAccessToken: action.token,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/fbuser.js